import cn from 'classnames';
import React from 'react';

import s from './index.scss';

const Modal = ({style = {}, onClose, title, tips, children, size = 'normal'}) => (
    <div
        className={cn(s.container, s[size], 'fuck-modal')}
        style={title ? {...style} : {paddingTop: 0, ...style}}
    >
        {
            onClose &&
            <i
                className={s.closeBtn}
                onClick={onClose}
            />
        }
        {
            title &&
            <h3 className={s.title}>{title}</h3>
        }
        <div
            className={s.content}
            style={title ? {} : {marginTop: `${8 / 24}rem`}}
        >
            {
                tips && size === 'normal' &&
                <p className={s.tips}>{tips}</p>
            }
            {children}
        </div>
    </div>
);

const Item = ({style, children, tips, theme}) => (
    <div
        className={s.item}
        style={style}
    >
        {
            tips &&
            <p className={cn(s.tips, theme ? s[theme] : '')}>{tips}</p>
        }
        {children}
    </div>
);

Modal.Item = Item;

export default Modal;
